define(
  'areaFilterHandler',[
    'builderShowcaseObserver',
    'GeoFiltering',
    'event'
  ],
  (builderShowcaseObserver, GeoFilter) => {
    'use strict';

    function AreaFilterInitHandler() {
    }

    /**
    * @private
    * SetListenersStarsSort: set the stuff related to the area filter.
    *
    */
    function InitAreaFilter() {
      // eslint-disable-next-line no-unused-vars
      const geoFilter = new GeoFilter({
        controls: {
          FilterArea: 'loadPage'
        },
        getPage: {
          FilterArea: (e) => {
            const optionSelected = e.options[e.selectedIndex];
            return optionSelected ? optionSelected.getAttribute('value') : '';
          }
        },
        trigger: ['#FilterArea'],
        event: ['change'],
        completeUrl: true
      });
    }

    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    AreaFilterInitHandler.update = function SetListeners() {
      InitAreaFilter();
    };

    InitAreaFilter();
    builderShowcaseObserver.subscribe('onReviewsSectionLoaded', AreaFilterInitHandler);
  }

);

